module.exports = __webpack_public_path__ + "img/repair.9e098b91.svg";